const isRoot = (state, dataType, id) => {
  const rootItem = state.settings.rootItem

  return rootItem.type === dataType && rootItem.id === id
}

export default isRoot



// WEBPACK FOOTER //
// ./src/utils/isRoot.js